import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdministrationCustomerAPIKeysService,
  CustomerApiKeyModel,
  CustomerApiKeyRequest
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class AdministrationCustomerAPIKeysApiService {
  constructor(private apiService: AdministrationCustomerAPIKeysService) {}

  public issueApiKey(customerId: string, customerApiKeyRequest?: CustomerApiKeyRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerApiKeyModel> {
    return this.apiService.adminCustomerApiKeyIssue(customerId, customerApiKeyRequest, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public listApiKeys(customerId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerApiKeyModel[]> {
    return this.apiService.adminCustomerApiKeyList(customerId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public revokeApiKey(customerId: string, keyId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerApiKeyModel> {
    return this.apiService.adminCustomerApiKeyRevoke(customerId, keyId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
